module.exports = __webpack_public_path__ + "static/advice1-a921d6c33137dfc635076c308db7ad79.png";